module.exports = __webpack_public_path__ + "img/night-sweats.45ce8e4a.svg";